import { useEffect } from 'react'
import { usePreferences } from '../preferences/PreferencesContext'
import { useOnlineStatus } from './useOnlineStatus'
import { maybeAutoDownload } from '../lib/offline/autoDownload'

/**
 * Fire-and-forget: when a surah is playing and the auto-download setting is
 * on, save it for offline in the background. Mounted on both playback
 * surfaces (reader page and the app-root playlist provider).
 */
export function useAutoDownloadOnPlay({
  surahNumber,
  isPlaying,
}: {
  surahNumber: number | null
  isPlaying: boolean
}): void {
  const { prefs } = usePreferences()
  const isOnline = useOnlineStatus()

  useEffect(() => {
    if (!isPlaying || surahNumber === null) return
    void maybeAutoDownload({
      enabled: prefs.autoDownloadOnPlay,
      isOnline,
      surahNumber,
      reciter: prefs.reciter,
      edition: prefs.edition,
      budgetMB: prefs.offlineDataBudgetMB,
    })
  }, [
    isPlaying,
    surahNumber,
    isOnline,
    prefs.autoDownloadOnPlay,
    prefs.reciter,
    prefs.edition,
    prefs.offlineDataBudgetMB,
  ])
}
